import { Injectable } from '@angular/core';

import { TODO } from '@b2b/types/core/utils';

/**
 * VenueService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/venue/venue.service.js
 * (legacy AngularJS name 'VenueService'). Pure helpers for venue reseller/
 * group-buyer request status and open-hours formatting.
 *
 * Registered back into AngularJS under 'VenueService' via downgradeInjectable
 * in app/upgrade/ng-downgraded-components.ts.
 */
@Injectable({ providedIn: 'root' })
export class VenueService {
  requestTypes: string[] = ['reseller', 'groupBuyer'];

  init(): boolean {
    return true;
  }

  parseHours(hours: string): string {
    let s, a0, a1, h0, m0, h1, m1, t0, t1, time;

    // NOTE: legacy compared `indexOf('-') !== false` (number vs boolean), which is
    // always true. Preserved 1:1 — parseHours is only ever called with range
    // strings ("HH:MM-HH:MM"); the else branch was effectively dead.
    if ((hours.indexOf('-') as unknown) !== false) {
      s = hours.split('-');

      t0 = s[0].split(':');
      h0 = parseInt(t0[0], 10);
      m0 = t0[1];

      t1 = s[1].split(':');
      h1 = parseInt(t1[0], 10);
      m1 = t1[1];

      if (h0 >= 0 && h0 < 12) {
        a0 = 'AM';
      } else {
        a0 = 'PM';
        h0 -= 12;
      }

      if (h1 >= 0 && h1 < 12) {
        a1 = 'AM';
      } else {
        a1 = 'PM';
        h1 -= 12;
      }

      if (parseInt(m1, 10) === 0) {
        m1 = '';
      } else {
        m1 = ':' + m1;
      }

      if (parseInt(m0, 10) === 0) {
        m0 = '';
      } else {
        m0 = ':' + m0;
      }

      time = h0 + m0 + ' ' + a0;
      time += ' - ';
      time += h1 + m1 + ' ' + a1;
    } else {
      time = hours;
    }

    return time;
  }

  getStatusLabel(type: string, status: string): string {
    let s;
    let t = '';
    let r = '';

    if (status) {
      s = status.toLowerCase();

      switch (s) {
        case 'pending':
          r = 'Pending';
          if (type) {
            r += ' ';
          }
          break;
        case 'declined':
          r = 'Declined';
          if (type) {
            r += ' as ';
          }
          break;
        case 'approved':
          r = 'Approved';
          if (type) {
            r += ' as ';
          }
          break;
        default:
          r = 'Apply';
          if (type) {
            r += ' for ';
          }
      }
    }

    if (type) {
      switch (type) {
        case 'reseller':
          t = 'Reseller';
          break;
        case 'groupBuyer':
          t = 'Group Buyer';
          break;
      }
    }

    return r + t;
  }

  checkRequestAll(): boolean {
    let r = false;
    let applied = 0;
    let ii = 0;

    for (let i = 0; i < this.requestTypes.length; i++) {
      ii = this.requestTypes.length;
      if (this.hasApplied(this.requestTypes[i] as TODO)) {
        applied++;
      }
    }

    if (applied === ii) {
      r = true;
    }

    return r;
  }

  hasApplied(requests: TODO, type?: TODO): boolean {
    let r = false;

    if (requests instanceof Array) {
      for (let i = 0, ii = requests.length; i < ii; i++) {
        if (requests[i].type === type) {
          r = true;
          break;
        }
      }
    }

    return r;
  }

  hasApproved(requests: TODO): boolean {
    let r = false;

    if (requests instanceof Array) {
      for (let i = 0, ii = requests.length; i < ii; i++) {
        if (requests[i].status === 'approved') {
          r = true;
          break;
        }
      }
    }

    return r;
  }

  processHours(venue: TODO): TODO {
    if (venue.openHours && venue.openHours.standard) {
      for (let i = 0, ii = venue.openHours.standard.length; i < ii; i++) {
        venue.openHours.standard[i].day = venue.openHours.standard[i].weekdays[0].substring(0, 3);
        venue.openHours.standard[i].times = [];
        for (let j = 0, jj = venue.openHours.standard[i].hours.length; j < jj; j++) {
          venue.openHours.standard[i].times.push(this.parseHours(venue.openHours.standard[i].hours[j]));
        }
      }
    }
    return venue;
  }

  process(venues: TODO[]): TODO[] {
    for (let i = 0, ii = venues.length; i < ii; i++) {
      if (venues[i].openHours) {
        venues[i] = this.processHours(venues[i]);
      }
    }

    return venues;
  }
}
